<template>
  <div class="SubscriptionError">
    <confirmation-banner
      icon-name="error"
      :title="$t('payment_failed.title', 'Oops,something went wrong')"
      :description="$t('payment_failed.subTitle', 'Your payment didn\'t go through.Please, review your payment details to fix the problem or contact support for more information.  ')"
    />
    <div class="SubscriptionError_body">
      <div class="backpage container">
        <router-link
          :to="RedirectToCart"
          class="AppButton back"
          @click.native="trackConversion({ name: 'interaction', description: 'back_to_payment_details' })"
        >
          ‹ {{ $t('payment_failed.button.back', 'Back to payment details') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import ConfirmationBanner from 'components/ConfirmationBanner'
  import { detectedCulture } from '@/utilities/common/culture'

  export default {
    name: 'subscription-error',

    components: {
      ConfirmationBanner
    },

    computed: {
      canadaLanguage () {
        return window.localStorage.getItem('canadaLanguage')
      },

      isCanadaSite () {
        return detectedCulture.code === 'en-ca'
      },

      isBelgiumsite () {
        return detectedCulture.code === 'nl-be'
      },

      queryLanguage () {
        if (this.isCanadaSite) {
          if (this.canadaLanguage) {
            return this.canadaLanguage
          } else {
            return 'en-CA'
          }
        }
      },

      RedirectToCart () {
        const lastBundle = window.localStorage.getItem('lastBundle')
        if (this.isCanadaSite) {
          return {
            path: '/checkout',
            query: {
              bundle: lastBundle,
              language: this.queryLanguage
            }
          }
        } else {
        if (this.isBelgiumsite) {
          return {
            path: '/checkout',
            query: {
              bundle: lastBundle,
              language: this.queryLanguage
            }
          }
        } else {
          return {
            path: '/checkout',
            query: {
              bundle: lastBundle
            }
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  .SubscriptionError {
    &_body {
      padding: .27rem 0 1rem;
      text-align: center;

      @include media(tablet) {
        padding: .37rem 0 1.25rem;
      }

      .backpage {
        .back {
          background: $white;
          color: $blue;
          border: .01rem solid $blue;
          padding: .07rem .15rem;
          font-weight: 400;

          @include media(tablet) {
            min-width: 3.55rem;
          }
        }
      }
    }
  }
</style>
